import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TbCar } from "react-icons/tb";

import CommonPopup from "@/components/CommonPopup";
import { useUsersShowUpdateUserTypeDialog, useUsersTableActions } from "@/stores/use-users-table";

import UpdateUserTypeDialog from "./UpdateUserTypeDialog";

function UpdateUserTypeComp() {
    const { t } = useTranslation();
    const showUpdateUserTypeDialog = useUsersShowUpdateUserTypeDialog();
    const { updateShowdUpdateUserTypeDialog } = useUsersTableActions();
    const onClose = () => {
        updateShowdUpdateUserTypeDialog();
    };

    return (
        <CommonPopup
            title={t("buttons.updateUserType")}
            icon={TbCar}
            open={!!showUpdateUserTypeDialog}
            size="sm"
            onClose={onClose}
        >
            <>
                <Alert severity="info">
                    Kullanıcı tipini seçiniz. <span className="font-semibold">Şoför</span> ve{" "}
                    <span className="font-semibold">Karşılama Ekibi</span> üyesi mesai işlemlerini yapabilmektedir.
                </Alert>
                <UpdateUserTypeDialog />
            </>
        </CommonPopup>
    );
}

export default UpdateUserTypeComp;
